module.exports = __webpack_public_path__ + "img/level2addon_mining_tool_shadow-1.a9e83d15.png";